const env = process.env.PROCESS_ENV ? process.env.PROCESS_ENV : 'dev'

const config = {}

if (env === 'dev') {
  Object.assign(config, {
    ENV: 'dev',
    keyValueHost: '//ai-h5-test.61info.cn'
  })
} else if (env === 'test') {
  Object.assign(config, {
    ENV: 'test',
    keyValueHost: '//ai-h5-test.61info.cn'
  })
} else if (env === 'pre') {
  Object.assign(config, {
    ENV: 'pre',
    keyValueHost: '//ai-h5-preprod.61info.cn'
  })
} else if (env === 'prod') {
  Object.assign(config, {
    ENV: 'prod',
    keyValueHost: '//ai-h5.61info.cn'
  })
}

export default config
